import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'management.bulkimport',
  path: '/management/bulk-import',
  title: 'Bulk Import',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);